import ChecklistItemConnected from './ChecklistItemConnected'
export default ChecklistItemConnected
